import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';


@Injectable()
export class ConfigurationService {
  enrollCountryCode: string;
  storeId: number;
  personalInfoSchemaURL: string;
  bonusInfoSchemaUrl: string;
  language: string;
  bonusInfoCountry: string;

  constructor(private _http: Http) { }

  /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }

  /**
   * To get list of Purchase Flows
   * @returns Observable
   */
  getPurchaseFlows() {
    const getPurchaseFlowUrl =
      ApiUrlConstants.configurationApiUrl + 'purchaseflows';

    return this._http
      .get(getPurchaseFlowUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  /**
   * To get country by id
   * @returns Observable
   */
  getCountryById(id: number) {
    const getCountryUrl = ApiUrlConstants.configurationApiUrl + 'countries/' + id;
    return this._http
      .get(getCountryUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  /**
   * @description
   * @date 2018-09-07
   * @returns {string}
   * @memberof ConfigurationService
   */
  getEnrollCountry(): string {
    return this.enrollCountryCode;
  }

  /**
   * @description
   * @date 2018-09-07
   * @returns {string}
   * @memberof ConfigurationService
   */
  setEnrollCountry(enrollCountryCode) {
    this.enrollCountryCode = enrollCountryCode;
  }

  
  setStoreID(storeId){
    this.storeId= storeId;
  }

  getStoreID(): number{
    return this.storeId;
  }

  setPersonalInfoSchemaURL(personalInfoSchemaURL){
    this.personalInfoSchemaURL = personalInfoSchemaURL;
  }

  getPersonalInfoSchemaURL(): string{
    return this.personalInfoSchemaURL;
  }

  setBonusInfoSchemaUrl(bonusInfoSchemaUrl){
    this.bonusInfoSchemaUrl = bonusInfoSchemaUrl;
  }

  getBonusInfoSchemaUrl(): string{
    return this.bonusInfoSchemaUrl;
  }

  setLanguageCulture(language){
    this.language = language;
  }

  getLanguageCulture(): string{
    return this.language;
  }

  getStoreByCountry(countryCode: string): Observable<any> {
    const getConfigurationUrl = ApiUrlConstants.configurationApiUrl + 'store-countries/' + countryCode.toUpperCase();
    return this._http
      .get(getConfigurationUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  setBonusInfoCountry(countryCode: string){
    this.bonusInfoCountry = countryCode;
  }

  getBonusInfoCountry() {
    return this.bonusInfoCountry;
  }

  /**
   * @description
   * To Fetch Business Entity details based on Operating country Id
   * @param operatingCountryId 
   * @returns
   */
  getBusinessEntityDetails(operatingCountryId): Observable<any> {
    const getBusinessEntityUrl = ApiUrlConstants.configurationApiUrl + 'business-entities/' + operatingCountryId;
    return this._http
      .get(getBusinessEntityUrl)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
    }
  

    /**
   * @description
   * To Check the WorldPayPayment based on countryCode
   * @param countryCode 
   * @returns
   */
    // checkWorldPayEnabledCountry(countryCode: string): boolean {
  //     if(environment.worldpayPaymentCountries){
  //         const worldpayPaymentCountries = environment.worldpayPaymentCountries.toLowerCase().split(',');
  //         if(worldpayPaymentCountries && worldpayPaymentCountries.length) {
  //             return worldpayPaymentCountries.some((worldpayPaymentCountryCode) => worldpayPaymentCountryCode.toLowerCase() === countryCode.toLowerCase());
  //         }
  //     }
  //     return false;
  // }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/configuration.service.ts